import { $win, getCurrentDevice } from './utils';

export default function headerUI() {
	$('.footer__nav__title').on('click', function() {
		const $this = $(this);

		$this.toggleClass('active');

		$this.next().slideToggle();
	})
}
